import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import DefaultPage from "../DefaultPage/DefaultPage";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import "./MandatoryPage.css";
import MandatoryInfo from "./MandatoryInfo";
import Loader from "../../components/Loader";

const MandatoryPage = () => {
  //fetch úvodu
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(
    `${config.api}/api/mandatory-disclosed-information-page?populate=background`
  );

  //fetch povinne zverejnovanych informaci
  const { loading, error, data } = useFetch(
    `${config.api}/api/mandatory-disclosed-informations?sort=index`
  );

  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání informací" />;

  if (!data || !data.data) return <DefaultPage message="Žádné informace" />;

  //? test
  //? console.log(data.data);

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5">
          <div className="row">
            {data.data.map((information) => (
              <MandatoryInfo
                key={information.id}
                index={information.index}
                title={information.title}
                text={information.text}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default MandatoryPage;
